import { getProjectId } from "../../../utilities/firebase_utils";

/**
 * LLM-guided onboarding is the DEFAULT onboarding in local / dev / qa; production keeps the legacy
 * modal flow until we explicitly flip it. Gate by project id (prod = arcwise-ad50c) so it's
 * environment-wide, not per-org. One source of truth for both the route guard and the redirect.
 */
const PROD_PROJECT_ID = "arcwise-ad50c";

export const llmOnboardingEnabled = () => getProjectId() !== PROD_PROJECT_ID;
